import axios from 'axios'

export const prodCfg = {
    baseURL: 'https://market.bigmama.network/api/',
    portsBaseURL: 'https://ports.bigmama.network/api/',
    authBaseURL: ' https://auth.bigmama.network/v2/'
}

export const stageCfg = {
    baseURL: 'https://market-stg.bigmama.network/api/',
    portsBaseURL: 'https://ports.bigmama.network/api/',
    authBaseURL: ' https://auth-stg.bigmama.network/'
}

export const localCfg = {
    baseURL: 'https://market.bigmama.network/api/',
    portsBaseURL: 'https://ports.bigmama.network/api/',
    authBaseURL: 'https://auth.bigmama.network/v2/'
}

export const getCfgByOrigin = () => {
    switch (window.location.origin) {
        case "http://localhost:3000": // used in tests
            return localCfg
        case "https://localdev":
            return localCfg
        case "https://market-stg.bigmama.network":
            return stageCfg
        case "https://market.bigmama.network":
            return prodCfg
        default:
            throw Error("no APIClient config for origin")
    }
}

export const AUDIENCE = {
    audience: "https://collector"
}


class APIClient {
    constructor(cfg) {
        this.cfg_ = cfg
        const axiosCfg = {
            baseURL: cfg.baseURL,
            timeout: cfg.timeout || 60000,
        }
        this.axios_ = axios.create(axiosCfg)
    }

    onError(f) {
        this.errorHandler_ = f
        return this
    }

    onAuthNeeded(f) {
        this.authHandler_ = f
        return this
    }

    onServerUnreachable(f) {
        this.serverUnreachableHandler_ = f
        return this
    }

    onBadGateway(f) {
        this.badGatewayHandler_ = f
        return this
    }

    withToken(getToken) {
        return new APIClientWithToken(this, getToken)
    }
}

const queryToParamMap = {
    'country': 'cc',
    'city': 'city',
    'zip': 'zip',
    'isp': 'isp',
    'region': 'reg',
    'ip1': 'ip1',
    'ip2': 'ip2',
    'conn': 'conn',
    'leases': 'leases',
    'fresh': 'fresh',
    'stars': 'exstars',
    'geoCentralZip': 'geozip',
    'geoSearchRadius': 'georad',
    'dev': 'dev',
}

export const LEASE_STATUS_CREATED = "LEASE_STATUS_CREATED"
export const LEASE_STATUS_PROBE_FAILED = "LEASE_STATUS_PROBE_FAILED"
export const LEASE_STATUS_PRICE_CHANGED = "LEASE_STATUS_PRICE_CHANGED"
export const LEASE_STATUS_NOT_ENOUGH_FUNDS = "LEASE_STATUS_NOT_ENOUGH_FUNDS"
export const LEASE_STATUS_AGENT_INFO_CHANGED = "LEASE_STATUS_AGENT_INFO_CHANGED"
export const LEASE_STATUS_AGENT_ALREADY_LEASED = "LEASE_STATUS_AGENT_ALREADY_LEASED"
export const LEASE_STATUS_AGENT_NOT_FOUND = "LEASE_STATUS_AGENT_NOT_FOUND"
export const LEASE_STATUS_GENERIC_ERROR = "LEASE_STATUS_GENERIC_ERROR"

export const REFUND_STATUS_REFUNDED = "REFUND_STATUS_REFUNDED"
export const REFUND_STATUS_INELIGIBLE = "REFUND_STATUS_INELIGIBLE"
export const REFUND_STATUS_ALIVE = "REFUND_STATUS_ALIVE"

export const RENEW_STATUS_RENEWED = "RENEW_STATUS_RENEWED"
export const RENEW_STATUS_NOT_ENOUGH_FUNDS = "RENEW_STATUS_NOT_ENOUGH_FUNDS"
export const RENEW_STATUS_FAILED = "RENEW_STATUS_FAILED"

export const SCORECHECK_OK = "SCORECHECK_OK"
export const SCORECHECK_RATE_LIMITED = "SCORECHECK_RATE_LIMITED"
export const SCORECHECK_INSUFFICENT_FUNDS = "SCORECHECK_INSUFFICENT_FUNDS"
export const SCORECHECK_CONFLICT = "SCORECHECK_CONFLICT"
export const SCORECHECK_OTHER_ERROR = "SCORECHECK_OTHER_ERROR"

export const AUTHPORT_CREATED = "AUTHPORT_CREATED"
export const AUTHPORT_ERROR = "AUTHPORT_ERROR"

export const CHARGESTATUS_OK = "CHARGESTATUS_OK"
export const CHARGESTATUS_ERROR = "CHARGESTATUS_ERROR"

export const PORT_CREATED = "PORT_CREATED"
export const PORT_CREATE_ERROR = "PORT_CREATE_ERROR"
export const PORT_LOADED = "PORTS_LOADED"
export const PORT_LOAD_ERROR = "PORT_LOAD_ERROR"
export const COUNTRY_LIST_LOADED = "COUNTRY_LOADED"
export const COUNTRY_LIST_LOAD_ERROR = "COUNTRY_LOAD_ERROR"
export const PRICE_LOADED = "PRICE_LOADED"
export const PRICE_LOADED_ERROR = "PRICE_LOADED_ERROR"
export const PORT_WHITELIST_UPDATED = "PORT_WHITELIST_UPDATED"
export const PORT_WHITELIST_ERROR = "PORT_WHITELIST_ERROR"

export const PORT_REFUNDED = "PORT_REFUNDED"
export const PORT_REFUNDED_ERROR = "PORT_REFUNDED_ERROR"
export const PORT_REACTIVATED = "PORT_REACTIVATED"
export const PORT_REACTIVATED_ERROR = "PORT_REACTIVATED_ERROR"

export const PORT_REGION_LOADED = "PORT_REGION_LOADED"
export const PORT_REGION_LOAD_ERROR = "PORT_REGION_LOAD_ERROR"
export const PORT_CITY_LOADED = "PORT_CITY_LOADED"
export const PORT_CITY_LOAD_ERROR = "PORT_CITY_LOAD_ERROR"
export const PORT_WHITELIST_TO_LOGIN_UPDATED = "PORT_WHITELIST_TO_LOGIN_UPDATED"
export const PORT_WHITELIST_TO_LOGIN_ERROR = "PORT_WHITELIST_TO_LOGIN_ERROR"

export const GET_USERINFO_BY_EMAIL_SUCCESS = "GET_USERINFO_BY_EMAIL_SUCCESS"
export const GET_USERINFO_BY_EMAIL_ERROR = "GET_USERINFO_BY_EMAIL_ERROR"

export const LOAD_STATIC_SUCCESS = "LOAD_STATIC_SUCCESS"
export const LOAD_STATIC_FAILED = "LOAD_STATIC_FAILED"

export const STATIC_LEASE_STATUS_CREATED = "STATIC_LEASE_STATUS_CREATED"


class APIClientWithToken {
    constructor(parent, getToken) {
        this.p_ = parent
        this.getToken_ = getToken
    }

    async loadAgents(query, cursor = 0, limit = 10, opts) {
        const params = {
            'cursor': cursor,
            'segments': true,
            'limit':limit,
        }
        for (const queryField in queryToParamMap) {
            if (query[queryField]) {
                params[queryToParamMap[queryField]] = query[queryField]
            }
        }
        
        return this.call_({uri: '/agents', params, ...opts})
        // return this.devCallAPINoGlobalError_({uri: '/agents', params, ...opts})
    }

    async loadAgentTotals(opts) {
        return this.call_({uri: '/totals/agents?all=true', ...opts})
    }

    async loadSingleAgent(id, opts) {
        return this.call_({uri: '/agents/' + id, ...opts})
    }

    async loadAllActiveLeases(opts) {
        let leases = []

        try {
            let cursor = 0
            do {
                const resp = await this.call_({uri: '/leases', params: { cursor }, ...opts})
                // const resp = await this.devCallAPINoGlobalError_({uri: '/leases', params: { cursor }, ...opts})
                // const resp = {"leases":[{"self":"/api/leases/QYVO-3954","id":"QYVO-3954","user":"urn:user:auth0|6302545e42b9ab57358328eb","agent":"/api/agents/STWM-7592","agentId":"STWM-7592","info":{"ip":"107.127.26.161","loc":{"cc":"US","reg":"California","city":"San Diego","zip":"92105","isp":"AT\u0026T Wireless"},"score":-1,"leases":{"count":1,"worn":false},"age":13145303183924670,"firstSeen":"2022-07-22T12:57:45Z","actv":0.205,"probeActv":0.17221,"conn":"cell","blacklists":{"listIDs":["sbl.spamhaus.org","noptr.spamrats.com"]}},"currentInfo":{"ip":"166.194.148.97","host":"mobile-166-194-148-097.mycingular.net","loc":{"cc":"US","reg":"Pennsylvania","city":"Doylestown","isp":"AT\u0026T Wireless"},"score":-1,"leases":{"count":1,"worn":false},"age":13220303187495601,"firstSeen":"2022-07-22T12:57:45Z","actv":0.205,"probeActv":0.17221,"conn":"cell","blacklists":{"listIDs":["xbl.spamhaus.org"]}},"start":"2022-12-21T16:39:45.202554253Z","until":"2022-12-22T16:39:45.202554253Z","exc":true,"socks":{"host":"157.90.30.80","ip":"157.90.30.80","port":1080,"user":"b99xjwb1bs67","pwd":"2k3t3p1yp9c1x"},"stats":{"reqs":0,"inBytes":0,"outBytes":0,"failPct":0,"refundable":false},"purchasePriceC":168,"renewable":true,"autoRenew":false,"authPort":{"leaseID":"QYVO-3954","node":"157.90.26.242","whitelist":"188.130.178.49","port":42673}}],"cursor":0}
                leases = [...leases, ...resp.leases]
                cursor = resp.cursor
            } while(cursor !== 0)
        } catch (err) {
            return Promise.reject(err)
        }

        return leases
    }

    async requestRefund(leaseId, opts) {
        try {
            await this.call_({uri: '/leases/' + leaseId, ignoreStatuses: [400, 409], ...opts}, 'DELETE')
            return REFUND_STATUS_REFUNDED
            // return null
        } catch (err) {
            let errorStatus = REFUND_STATUS_INELIGIBLE
            if (err.response) {
                const errorCode = err.response.data?.errorCode
                
                switch (err.response.status) {
                case 409:
                    if (errorCode === 'agentNotDead') {
                        errorStatus = REFUND_STATUS_ALIVE
                    } else if (errorCode === 'notRefundable') {
                        errorStatus = REFUND_STATUS_ALIVE
                    }
                    break
                case 400:
                    if (errorCode === 'leaseNotEligible') {
                        errorStatus = REFUND_STATUS_INELIGIBLE
                    }
                    break
                default:
                    errorStatus = REFUND_STATUS_INELIGIBLE
                }
            }

            return errorStatus // this.handleError_(err, opts)
        }
    }

    async loadOrCreateAccount(opts) {
        try {
            return await this.call_({uri: '/accounts/my', ignoreStatuses: [404], ...opts})
        } catch (err) {
            if (err?.response?.status !== 404) {
                // return Promise.reject(new Error('failed to get the account (non-404):' + err))
                throw err
            }
            return await this.call_({uri: '/accounts/my', ...opts}, 'PUT', {})
        }
    }

    async createLease(agentId, expPriceC, probe, exclusive, opts) {
        const reqJson = {
            agentID: agentId,
            expPriceC,
            probe,
            exc: exclusive,
        }

        const ignoreStatuses = [409, 402]

        try {
            const res = await this.call_({uri: '/leases', ignoreStatuses, ...opts}, 'POST', reqJson)
            return [LEASE_STATUS_CREATED, res]
        } catch (err) {
            let errorStatus = null
            // console.log('RESPONSE ERROR STATUS : '+err.response.status)
            if (err.response) {
                const errorCode = err.response.data
                // console.log('errorCode : ' + errorCode)
                // console.log('data')
                // console.log(err.response.data)
                switch (err.response.status) {
                case 409:
                    switch (errorCode) {
                    case 'probeErrAgent':
                        errorStatus = [LEASE_STATUS_PROBE_FAILED]
                        break
                    case 'priceChanged':
                        errorStatus = [LEASE_STATUS_PRICE_CHANGED]
                        break
                    case 'agentInfoChanged':
                        errorStatus = [LEASE_STATUS_AGENT_INFO_CHANGED, err.response.data.changes || []]
                        break
                    case 'agentAlreadyLeased':
                        errorStatus = [LEASE_STATUS_AGENT_ALREADY_LEASED]
                        break
                    case 'agentNotFound':
                        errorStatus = [LEASE_STATUS_AGENT_NOT_FOUND]
                        break
                    default:
                        errorStatus = [LEASE_STATUS_GENERIC_ERROR]
                    }
                    break
                case 402:
                    errorStatus = [LEASE_STATUS_NOT_ENOUGH_FUNDS]
                    break
                default:
                    errorStatus = [LEASE_STATUS_GENERIC_ERROR]
                }
            }
            // console.log('--------API ERROR----------')
            // console.log(err)
            // console.log('STATUS')
            // console.log(errorStatus)
            return errorStatus  //this.handleError_(err, opts)
        }
    }

    async renewLease(leaseId, opts) {
        try {
            await this.call_({uri: '/leases/' + leaseId, ignoreStatuses: [402], ...opts}, 'PATCH', '')
            return RENEW_STATUS_RENEWED
        } catch (err) {
            if (err.response?.status === 402) {
                return RENEW_STATUS_NOT_ENOUGH_FUNDS
            } else {
                // console.error("unexpected error renewing the lease: " + err)
            }

            return RENEW_STATUS_FAILED
        }
    }

    async loadStaticAgents(data, opts) {
        try {
            let result = await this.call_({uri: '/static/list/', params: data, ...opts}, 'GET')
            // let result = await this.devCallAPINoGlobalError_({uri: '/static/list/', params: data, ...opts}, 'GET')
            return [LOAD_STATIC_SUCCESS, result]
        } catch (err) {
            // console.error("loadStaticAgents : " + err)

            return [LOAD_STATIC_FAILED, err]
        }
    }

    async createStaticLease(agentId, expPriceC, opts) {
        const reqJson = {
            agentID: agentId.toString(),
            expPriceC,
        }

        const ignoreStatuses = [409, 402]

        try {
            const res = await this.call_({uri: '/static/lease', ignoreStatuses, ...opts}, 'POST', reqJson)
            // const res = await this.devCallAPINoGlobalError_({uri: '/static/lease', ignoreStatuses, ...opts}, 'POST', reqJson)
            
            return [STATIC_LEASE_STATUS_CREATED, res]
        } catch (err) {
            let errorStatus = null
            // console.log('RESPONSE ERROR STATUS : '+err.response.status)
            if (err.response) {
                const errorCode = err.response.data
                switch (err.response.status) {
                case 409:
                    switch (errorCode) {
                    case 'agentAlreadyLeased':
                        errorStatus = [LEASE_STATUS_AGENT_ALREADY_LEASED]
                        break
                    case 'agentNotFound':
                        errorStatus = [LEASE_STATUS_AGENT_NOT_FOUND]
                        break
                    default:
                        errorStatus = [LEASE_STATUS_GENERIC_ERROR]
                    }
                    break
                case 402:
                    errorStatus = [LEASE_STATUS_NOT_ENOUGH_FUNDS]
                    break
                default:
                    errorStatus = [LEASE_STATUS_GENERIC_ERROR]
                }
            }
           
            return errorStatus
        }
    }

    async setLeaseAutoRenew(leaseId, set, opts) {
        return this.call_({uri: '/leases/' + leaseId + '/autoRenew?set=' + set, ignoreStatuses: [], ...opts}, 'PATCH', '')
    }

    async loadTxRecords(offset, limit, startDateIso, endDateIso, opts) {
        const params = {
            offset,
            limit,
            start: startDateIso,
            end: endDateIso,
        }
        return this.call_({uri: '/txrecords', params, ...opts})
    }

    async createCryptoCharge(amtUSDC, usedId, userEmail, currencyType, opts) {
        try {
            let res = await this.callPaymentAPINoGlobalError_({uri: '/crypto/create', ...opts}, 'POST', {'amount': amtUSDC , 'type': currencyType, 'user_id': usedId, 'user_email': userEmail})//{uid:'GS2GJSH6S',type:'ltc', amount: 0.0002323, status: 'no payments', address: 'Ldb5dXtZ72JAV8wekySaGJc3CAthaGmXUh'}
            
            return res
        }catch(e){
            // console.log('ERORR1')
            // console.log(e)
            return e
        }
        
    }

    // async createCryptoCharge(amtUSDC, usedId, userEmail, currencyType, opts) {
    //     return {uid:'2ee02093-8183-43af-b0ca-b05aa3a79b5b',type:'trc20usdt', amount: 0.00024, status: 'no payments', address: '13Xseh8STudfFUxQYbx8J2C3n3zXz2248x'}
    // }

    async getChargeStatus(chargeUid, opts) {
        return this.callPaymentAPINoGlobalError_({uri: '/crypto/check', ...opts}, 'POST', {'uid': chargeUid })//{type:'ltc', amountCrypto: 0.0002323, status: 'pending', address: 'Ldb5dXtZ72JAV8wekySaGJc3CAthaGmXUh', amountUsd: 299, date:1657915930867,exchangeRate:5215,bonusType:15}
    }

    // async getChargeStatus(chargeUid, opts) {
    //     return {status: "no payments",address:"13Xseh8STudfFUxQYbx8J2C3n3zXz2248x",type:"btc",amountCrypto:0.00024}
    // }

    // returns null if not found
    async loadAccountInfo(userId, opts) {
        try {
            return await this.call_({uri: '/accounts/' + encodeURIComponent(userId), ignoreStatuses: [404], ...opts})
        } catch (err) {
            if (err.response?.status === 404) {
                return Promise.resolve(null)
            }
            this.handleError_(err)
        }
    }

    async adminBlockUser(userEmail, opts) {
        try {
            return await this.calAuthAPINoGlobalError_({uri: '/administator/user/block/', ...opts}, 'POST', {'email': userEmail})
        } catch (err) {
            if (err.response?.status === 404) {
                return Promise.resolve(null)
            }
            this.handleError_(err)
        }
    }


    async getUserInfoByEmail(email, opts) {
        try {
            const results = await this.calAuthAPINoGlobalError_({uri: '/administator/user/info/', ...opts}, 'POST', {'email': email})
            // const results = await this.devCallAPINoGlobalError_({uri: '/administator/user/info/', ...opts}, 'POST', {'email': email})
            return [GET_USERINFO_BY_EMAIL_SUCCESS, results]
        } catch (err) {
            if(err.response){
                let errorMsg = null
                switch (err.response.status) {
                    case 400:
                        errorMsg = err?.response?.error
                        break
                    default:
                        errorMsg = "global error"
                }

                return [GET_USERINFO_BY_EMAIL_ERROR, errorMsg]
            } else {
                this.handleError_(err)
            }
        }
    }

    async changeUserPassword(email, newpass, opts) {
        try {
            const results = await this.calAuthAPINoGlobalError_({uri: '/administator/user/password/change', ...opts}, 'POST', {'email': email, 'password':newpass})
            // const results = await this.devCallAPINoGlobalError_({uri: '/administator/user/info/', ...opts}, 'POST', {'email': email})
            return [GET_USERINFO_BY_EMAIL_SUCCESS, results]
        } catch (err) {
            if(err.response){
                let errorMsg = null
                switch (err.response.status) {
                    case 400:
                        errorMsg = err?.response?.error
                        break
                    default:
                        errorMsg = "global error"
                }

                return [GET_USERINFO_BY_EMAIL_ERROR, errorMsg]
            } else {
                this.handleError_(err)
            }
        }
    }

    async loadLeaseInfo(leaseId, opts) {
        try {
            return await this.call_({uri: '/leases/' + encodeURIComponent(leaseId), ignoreStatuses: [404], ...opts})
            // return {"self":"/api/leases/WKYX-5824","id":"WKYX-5824","user":"urn:user:auth0|629b444727acd7006a50f665","agent":"/api/agents/COQC-1923","agentId":"COQC-1923","info":{"ip":"174.204.71.98","host":"98.sub-174-204-71.myvzw.com","loc":{"cc":"US","reg":"Washington","city":"Seattle","zip":"98121","isp":"Verizon Business"},"score":-1,"leases":{"count":1,"worn":true},"age":0,"firstSeen":"2022-09-19T16:52:16Z","actv":0,"probeActv":0.45088,"conn":"cell"},"currentInfo":{"ip":"174.204.71.98","host":"98.sub-174-204-71.myvzw.com","loc":{"cc":"US","reg":"Washington","city":"Seattle","zip":"98121","isp":"Verizon Business"},"score":-1,"leases":{"count":0,"worn":true},"age":0,"firstSeen":"2022-09-19T16:52:16Z","actv":0,"probeActv":0.45088,"conn":"cell"},"start":"2022-09-24T12:14:45.267944342Z","until":"2022-09-25T12:14:45.267944342Z","exc":false,"socks":{"host":"157.90.26.242","ip":"157.90.26.242","port":1080,"user":"2iyodxz0ujli3","pwd":"35f2j52bt70p5"},"stats":{"reqs":0,"inBytes":0,"outBytes":0,"failPct":0,"refundable":false},"ended":true,"purchasePriceC":50,"renewable":false,"autoRenew":false,"authPort":{"leaseID":"","node":"","whitelist":"","port":0}}
        } catch (err) {
            if (err.response?.status === 404) {
                return Promise.resolve(null)
            }
            this.handleError_(err)
        }
    }

    async loadTransactionInfo(data, opts) {
        try {
            return await this.call_({uri: '/crypto/deep-check/'}, 'POST', data)
            //return [{"uid":"9b498d92-b4c9-4ef1-90c0-20475f47e022","user_id":"auth0|63347d0813df4870baa8cacd","user_email":"justgod@yahoo.com","type":"btc","address":"13yafFdbzk8XPTbVJijcRdVRCwtvqPG1Nh","amount":0.00103,"time_created":1665351617195,"block_time":1665352578,"txid":"a9c89da66bae6c8365ed403cd75ed4b9c057e56fcf4e254a286a37bc4acc7bd7","blockhash":"000000000000000000050767baca246c8e9f19ecd6b77228e0c72dc1ae292939","_id":"EfmkVGsOyewcSkFy","time_confirmed":1665355093281},{"uid":"062f94a2-8f7c-4ae3-9948-66bcd2ef0bfb","user_id":"auth0|63347d0813df4870baa8cacd","user_email":"justgod@yahoo.com","type":"btc","address":"1PsSnk5sZZAfqj58Pc73599W2NFoRJK8A2","amount":0,"time_created":1665358725588,"_id":"H6Jl17MbSw1xphrh"},{"uid":"62d6a7ee-a2a7-4cf3-a32d-795775a78435","user_id":"auth0|63347d0813df4870baa8cacd","user_email":"justgod@yahoo.com","type":"btc","address":"1AcNeqAAMGLBK2icqG2c5frXiucuSMGijy","amount":0.00154,"time_created":1664384294645,"block_time":1664384542,"txid":"054d58020bfb127381de1ae87d769b902d12f58d620d4d53aafa7323d47439a2","blockhash":"0000000000000000000042e8e6b6930c51be915d00f25cf9e69f4275aef5d219","_id":"jqcMVgVqvtk3HA9D","time_confirmed":1664385674528},{"uid":"fa781d9d-37e7-4d94-b5d4-dc1587bcde13","user_id":"auth0|63347d0813df4870baa8cacd","user_email":"justgod@yahoo.com","type":"btc","address":"1rxJ4UxBxNV83j4dUSkhifgu3UsKUQZd8","amount":0,"time_created":1665352129807,"_id":"kMEIBtJiek2Dj4n3"}]
        } catch (err) {
            if (err.response?.status === 404) {
                return Promise.resolve(null)
            }
            this.handleError_(err)
        }
    }

    async loadUserPaymentsData(offset, limit, startDateIso, endDateIso, uid, opts) {
        try {
            const params = {
                offset,
                limit,
                start: startDateIso,
                end: endDateIso,
                uid: uid
            }
            return this.call_({uri: '/txrecords', params, ...opts})
            // return this.devCallAPINoGlobalError_({uri: '/txrecords', params, ...opts})
            
        } catch (err) {
            if (err.response?.status === 404) {
                return Promise.resolve(null)
            }
            this.handleError_(err)
        }
    }

    async updateAccount(userId, updateJson, opts) {
        return await this.call_({uri: '/accounts/' + encodeURIComponent(userId), ...opts}, 'PATCH', updateJson)
    }

    async loadLeaseHistory(offset, limit, startDateIso, endDateIso, query, opts) {
        const params = {
            offset,
            limit,
            start: startDateIso,
            end: endDateIso,
            query: query,
        }
        return await this.call_({uri: '/leaseHistory', params, ...opts})
    }

    async setAgentNote(agentId, note, opts) {
        if (note) {
            return this.call_({uri: '/agentnotes/' + agentId, ...opts}, 'PUT', { 'note': note })
        } else {
            return this.call_({uri: '/agentnotes/' + agentId, ...opts}, 'DELETE')
        }
    }

    async loadSpeedCheck(agentId, update, opts) {
        try {
            return await this.call_({uri: '/agents/' + encodeURIComponent(agentId) + '/speedcheck' + (update ? '?request=true' : ''),
                            ignoreStatuses: [404, 409], ...opts})
        } catch (err) {
            if (err.response?.status === 409) {
                return {'rejected': true}
            } else if (err.response?.status === 404) {
                return {'notFound': true}
            } else {
                // console.error("unexpected error while loading the speedcheck: " + err)
                return {'failed': true}
            }
        }
    }

    async createScoreCheck(opts) {
        try {
            const resp = await this.call_({uri: '/agents/scorecheck', ignoreStatuses: [429], ...opts}, 'POST')
            return [SCORECHECK_OK, resp]
        } catch (err) {
            if (err.response?.status === 429) {
                return [SCORECHECK_RATE_LIMITED, null]
            } else {
                // console.error("unexpected error while creating a scorecheck: " + err)
                return [SCORECHECK_OTHER_ERROR, null]
            }
        }
    }

    async purchaseScoreCheck(proxyId, expectedPriceC, oneTimeToken, opts) {
        try {
            const resp = await this.call_({uri: '/agents/scorecheck', ignoreStatuses: [429, 402, 409, 500], ...opts}, 'PATCH',
                {agentID: proxyId, expectedPriceC, oneTimeToken})
            return [SCORECHECK_OK, resp]
        } catch (err) {
            if (err.response?.status === 429) {
                return [SCORECHECK_RATE_LIMITED, null]
            } else if (err.response?.status === 402) {
                return [SCORECHECK_INSUFFICENT_FUNDS, null]
            } else if (err.response?.status === 404) {
                return [SCORECHECK_OTHER_ERROR, null]
            } else {
                // console.error("unexpected error while requesting a scorecheck: " + err)
                return [SCORECHECK_OTHER_ERROR, null]
            }
        }
    }

    async createAuthPort(leaseId, whitelist, opts) {
        try {
            const resp = await this.callNoGlobalError_({uri: '/authport/create/'+leaseId, ...opts}, 'POST', whitelist)
//        	const resp = {node:"182.29.292.22", port:25122, whitelist:"78.129.169.15,78.129.169.11", leaseID:"iyJXyMaHk"}
            return [AUTHPORT_CREATED, resp]
        } catch (err) {
        	//   console.error("unexpected error while creating a auth port: " + err)
            return [AUTHPORT_ERROR, null]
        }
    }

    async createPort(portData, opts) {
        try {
            const resp = await this.callPortAPINoGlobalError_({uri: '/package/create', ...opts}, 'POST', portData)
       	    // const resp = {"result": "771c954a-c1ba-4066-a1d1-f0832190f767"}
            return [PORT_CREATED, resp]
        } catch (err) {
        	//   console.error("unexpected error while creating a port: " + err)
            return [PORT_CREATE_ERROR, null]
        }
    }

    async updatePortToWhitelistAuth(portData, opts) {
        try {
            const resp = await this.callPortAPINoGlobalError_({uri: '/port/update/whitelist', ...opts}, 'POST', portData)
       	    // const resp = {"result": "package 771c954a-c1ba-4066-a1d1-f0832190f767 ip whitelist updated"}
            return [PORT_WHITELIST_UPDATED, resp]
        } catch (err) {
        	//   console.error("unexpected error while updating a port whitelist: " + err)
            return [PORT_WHITELIST_ERROR, null]
        }
    }

    async updatePortLoginAuth(packageId, opts) {
        try {
            const resp = await this.callPortAPINoGlobalError_({uri: '/port/update/auth/'+packageId, ...opts}, 'GET', {})
       	    // const resp = {"result": "package 771c954a-c1ba-4066-a1d1-f0832190f767 ip whitelist updated"}
            return [PORT_WHITELIST_TO_LOGIN_UPDATED, resp]
        } catch (err) {
        	//   console.error("unexpected error while updating a port whitelist to login auth: " + err)
            return [PORT_WHITELIST_TO_LOGIN_ERROR, null]
        }
    }

    async loadPortsList(userId, opts) {
        try {
            const resp = await this.callPortAPINoGlobalError_({uri: '/users/'+userId+'/packages', ...opts}, 'GET', {})
            return [PORT_LOADED, resp]
        } catch (err) {
        	//   console.error("unexpected error while loading ports list: " + err)
            return [PORT_LOAD_ERROR, null]
        }
    }

    async getPortPrice(data, opts) {
        try {
            const resp = await this.callPortAPINoGlobalError_({uri: '/price', ...opts}, 'POST', data)
       	    // const resp = {"result": 26}
            return [PRICE_LOADED, resp]
        } catch (err) {
        	//   console.error("unexpected error while getting port price: " + err)
            return [PRICE_LOADED_ERROR, "error while getting port price"]
        }
    }

    async getRefundPort(packageId, opts) {
        try {
            const resp = await this.callPortAPINoGlobalError_({uri: '/package/refund/'+packageId, ...opts}, 'GET', {})
            // const resp = {"result": 26}
            return [PORT_REFUNDED, resp]
        } catch (err) {
            // console.error("unexpected error while refund port : " + err)
            return [PORT_REFUNDED_ERROR, "error while refund port"]
        }
    }

    async getReActivatePort(packageId, opts) {
        try {
            const resp = await this.callPortAPINoGlobalError_({uri: '/package/reactivate/'+packageId, ...opts}, 'GET', {})
            // const resp = {"result": 26}
            return [PORT_REACTIVATED, resp]
        } catch (err) {
            // console.error("unexpected error while reactivated port : " + err)
            return [PORT_REACTIVATED_ERROR, "error while reactivated port "]
        }
    }

    async loadCountryList(opts) {
        try {
            const resp = await this.callPortAPINoGlobalError_({uri: '/list/full', ...opts}, 'GET', {})
       	    // const resp = {"total":43493,"continent":[{"code":"AS","count":37144},{"code":"NA","count":3746},{"code":"EU","count":2054},{"code":"AF","count":284},{"code":"SA","count":237},{"code":"OC","count":28}],"country":[{"code":"YE","count":3},{"code":"US","count":3392},{"code":"ES","count":103},{"code":"BS","count":5},{"code":"CY","count":9},{"code":"TR","count":152},{"code":"GB","count":299},{"code":"DO","count":32},{"code":"KR","count":18},{"code":"TG","count":4},{"code":"IL","count":14},{"code":"DE","count":280},{"code":"BR","count":57},{"code":"CO","count":12},{"code":"JM","count":31},{"code":"UA","count":174},{"code":"PT","count":172},{"code":"MX","count":75},{"code":"IT","count":78},{"code":"LB","count":17},{"code":"CA","count":102},{"code":"NL","count":170},{"code":"AT","count":19},{"code":"AR","count":71},{"code":"CU","count":45},{"code":"EC","count":13},{"code":"PR","count":5},{"code":"NZ","count":6},{"code":"FR","count":158},{"code":"ZA","count":15},{"code":"PA","count":6},{"code":"NP","count":59},{"code":"MY","count":19},{"code":"SE","count":24},{"code":"VE","count":36},{"code":"CM","count":40},{"code":"LV","count":44},{"code":"CD","count":7},{"code":"AU","count":20},{"code":"VN","count":14},{"code":"SK","count":14},{"code":"PH","count":42},{"code":"KW","count":22},{"code":"QA","count":13},{"code":"RO","count":23},{"code":"JP","count":21},{"code":"TT","count":7},{"code":"DK","count":10},{"code":"RU","count":243},{"code":"SO","count":5},{"code":"HT","count":1},{"code":"BZ","count":2},{"code":"BI","count":12},{"code":"GR","count":20},{"code":"CZ","count":22},{"code":"HU","count":5},{"code":"RS","count":10},{"code":"PL","count":34},{"code":"MC","count":1},{"code":"KH","count":2},{"code":"CN","count":6},{"code":"CH","count":25},{"code":"PG","count":1},{"code":"LT","count":17},{"code":"GE","count":4},{"code":"NI","count":6},{"code":"UG","count":19},{"code":"SY","count":9},{"code":"CL","count":17},{"code":"HK","count":8},{"code":"DZ","count":7},{"code":"GH","count":14},{"code":"BW","count":1},{"code":"DJ","count":1},{"code":"MZ","count":2},{"code":"NO","count":3},{"code":"BG","count":12},{"code":"IE","count":19},{"code":"GT","count":10},{"code":"BH","count":5},{"code":"MA","count":15},{"code":"TH","count":17},{"code":"BB","count":2},{"code":"FI","count":20},{"code":"LY","count":4},{"code":"MM","count":19},{"code":"MU","count":2},{"code":"GA","count":2},{"code":"BJ","count":2},{"code":"GU","count":1},{"code":"SG","count":34},{"code":"RE","count":2},{"code":"SN","count":4},{"code":"TW","count":4},{"code":"HN","count":11},{"code":"BF","count":2},{"code":"RW","count":8},{"code":"CR","count":5},{"code":"TZ","count":4},{"code":"EE","count":4},{"code":"HR","count":5},{"code":"AE","count":34736},{"code":"SA","count":309},{"code":"IN","count":808},{"code":"ID","count":68},{"code":"BY","count":12},{"code":"IR","count":7},{"code":"GY","count":1},{"code":"PY","count":4},{"code":"NG","count":48},{"code":"KZ","count":4},{"code":"PK","count":522},{"code":"BM","count":1},{"code":"LK","count":23},{"code":"PE","count":12},{"code":"BD","count":102},{"code":"AZ","count":13},{"code":"BO","count":9},{"code":"UY","count":5},{"code":"MV","count":2},{"code":"BN","count":2},{"code":"JO","count":14},{"code":"LU","count":2},{"code":"CG","count":3},{"code":"MF","count":1},{"code":"YT","count":2},{"code":"MT","count":4},{"code":"BE","count":9},{"code":"SV","count":5},{"code":"OM","count":17},{"code":"EG","count":20},{"code":"IQ","count":3},{"code":"ET","count":5},{"code":"UZ","count":3},{"code":"AO","count":3},{"code":"SL","count":2},{"code":"SD","count":13},{"code":"MD","count":6},{"code":"KE","count":4},{"code":"MK","count":1},{"code":"AM","count":4},{"code":"KM","count":1},{"code":"PS","count":1},{"code":"SS","count":1},{"code":"AF","count":2},{"code":"TD","count":3},{"code":"CW","count":1},{"code":"SC","count":2},{"code":"TN","count":2},{"code":"TJ","count":1},{"code":"ZM","count":1},{"code":"ML","count":1},{"code":"CI","count":1},{"code":"SI","count":1},{"code":"VI","count":1}]}
            return [COUNTRY_LIST_LOADED, resp]
        } catch (err) {
        	//   console.error("unexpected error while loading ports list: " + err)
            return [COUNTRY_LIST_LOAD_ERROR, null]
        }
    }

    async loadRegionList(country, opts) {
        try {
            const resp = await this.callPortAPINoGlobalError_({uri: '/list/geo/state',params:{country:country}, ...opts}, 'GET', {})
            // const resp = {"total":43493,"regions":[{"state_code":"OH", "state_name":"Ohio","count":37144}, {"state_code":"OH", "state_name":"Ohio","count":37144}, {"state_code":"OH", "state_name":"Ohio","count":37144}]}
            return [PORT_REGION_LOADED, resp]
        } catch (err) {
            // console.error("unexpected error while reactivated port : " + err)
            return [PORT_REGION_LOAD_ERROR, "error while reactivated port "]
        }
    }

    async loadCitiesList(country, region, opts) {
        try {
            const resp = await this.callPortAPINoGlobalError_({uri: '/list/geo/city',params:{country:country, state:region}, ...opts}, 'GET', {})
            // const resp = {"total":43493,"cities":[{"name":"Alaska1","count":37144}, {"name":"New York2","count":37144}, {"name":"Wayoming2","count":37144}]}
            return [PORT_CITY_LOADED, resp]
        } catch (err) {
            // console.error("unexpected error while reactivated port : " + err)
            return [PORT_CITY_LOAD_ERROR, "error while reactivated port "]
        }
    }

    async call_(opts, method, body) {
        this.p_.axios_.defaults.baseURL = this.p_.cfg_.baseURL
        const uri = opts.uri
        method = method || 'GET'

        const params = opts.params || {}

        try {
            const token = await this.getToken_(AUDIENCE)
            const headers = {
                'authorization': 'Bearer ' + token,
            }

            const resp = await this.p_.axios_.request(uri, {
                method,
                headers,
                params,
                data: body,
            })

            return resp.data
        } catch (err) {
            return this.handleError_(err, opts)
        }
    }

    async callNoGlobalError_(opts, method, body) {
        this.p_.axios_.defaults.baseURL = this.p_.cfg_.baseURL
        const uri = opts.uri
        method = method || 'GET'
        const params = opts.params || {}

        try {
            const token = await this.getToken_(AUDIENCE)
            const headers = {
                'authorization': 'Bearer ' + token,
            }

            const resp = await this.p_.axios_.request(uri, {
                method,
                headers,
                params,
                data: body,
            })

            return resp.data
        } catch (err) {
            return Promise.reject(err)
        }
    }

    async callPortAPINoGlobalError_(opts, method, body) {
        this.p_.axios_.defaults.baseURL = this.p_.cfg_.portsBaseURL
        const uri = opts.uri
        method = method || 'GET'
        const params = opts.params || {}

        try {
            const token = await this.getToken_(AUDIENCE)
            const headers = {
                'authorization': 'Bearer ' + token,
            }

            const resp = await this.p_.axios_.request(uri, {
                method,
                headers,
                params,
                data: body,
            })
            if (resp?.data?.error !== undefined) {
              throw new 'error'
            }
            return resp.data
        } catch (err) {
            return Promise.reject(err)
        }
    }

    async callPaymentAPINoGlobalError_(opts, method, body) {
        this.p_.axios_.defaults.baseURL = prodCfg.baseURL
        const uri = opts.uri
        method = method || 'GET'
        const params = opts.params || {}

        try {
            const token = await this.getToken_(AUDIENCE)
            const headers = {
                'authorization': 'Bearer ' + token,
            }

            const resp = await this.p_.axios_.request(uri, {
                method,
                headers,
                params,
                data: body,
            })

            // console.log(resp)
            if (resp?.data?.error !== undefined) {
                // console.log('ERROR1')
              throw resp
            }
            return resp
        } catch (err) {
            // console.error(err.response.status)
            // console.log(err)
            // return Promise.reject(err)
            throw err
        }
    }

    async calAuthAPINoGlobalError_(opts, method, body) {
        this.p_.axios_.defaults.baseURL = this.p_.cfg_.authBaseURL
        const uri = opts.uri
        method = method || 'GET'
        const params = opts.params || {}

        try {
            const token = await this.getToken_(AUDIENCE)
            const headers = {
                'authorization': 'Bearer ' + token,
            }

            const resp = await this.p_.axios_.request(uri, {
                method,
                headers,
                params,
                data: body,
            })
            if (resp?.data?.error !== undefined) {
              throw new 'error'
            }
            return resp.data
        } catch (err) {
            return Promise.reject(err)
        }
    }

    async devCallAPINoGlobalError_(opts, method, body) {
        this.p_.axios_.defaults.baseURL = 'https://market.stage.bigmama.network/api/'
        const uri = opts.uri
        method = method || 'GET'
        const params = opts.params || {}

        try {
            const token = await this.getToken_(AUDIENCE)
            const headers = {
                'authorization': 'Bearer ' + token,
                'Access-Control-Allow-Origin': '*',
            }

            const resp = await this.p_.axios_.request(uri, {
                method,
                headers,
                params,
                mode: 'cors',
                data: body,
                timeout: 1000 * 5,
            })
            if (resp?.data?.error !== undefined) {
              throw new 'error'
            }
            return resp.data
        } catch (err) {
            return Promise.reject(err)
        }
    }

    handleError_(err, opts) {
        opts = opts || {}
        const ignoreOffline = opts.ignoreOffline
        const ignoreBadGateway = opts.ignoreBadGateway
        const ignoreStatuses = opts.ignoreStatuses || []

        if (err.response) {
            switch (err.response.status) {
            case 401:
                if (this.p_.authHandler_) {
                    this.p_.authHandler_()
                }
                return Promise.reject(new Error('got a 403'))
            case 502:
                if (this.p_.badGatewayHandler_ && !ignoreBadGateway) {
                    this.p_.badGatewayHandler_(err)
                }
                return Promise.reject(new Error('got a 502'))
            default:
                if (ignoreStatuses.includes(err.response.status)) {
                    return Promise.reject(err)
                }
            }
        } else if (err.request) {
            if (this.p_.serverUnreachableHandler_ && !ignoreOffline) {
                this.p_.serverUnreachableHandler_(err)
            }
            return Promise.reject(err)
        }

        if (this.p_.errorHandler_) {
            this.p_.errorHandler_(err)
        }
        return Promise.reject(err)
    }
}

export default APIClient
